module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      'height': _vm.innerHeight
    }),
    attrs: {
      "id": "app"
    }
  }, [(_vm.WeChat) ? _c('img', {
    staticClass: "szxx_banner",
    staticStyle: {
      "background-color": "slategray"
    },
    attrs: {
      "src": require("./assets/timg.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "szxx_banner",
    attrs: {
      "src": require("./assets/banner.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view', {
    staticClass: "router_view"
  })], 1), _vm._v(" "), _c('gotoRegister')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d481158"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 199
// module chunks = 12